import { render, staticRenderFns } from "./login-with-password.vue?vue&type=template&id=04c9de07&"
import script from "./login-with-password.vue?vue&type=script&lang=js&"
export * from "./login-with-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c9de07')) {
      api.createRecord('04c9de07', component.options)
    } else {
      api.reload('04c9de07', component.options)
    }
    module.hot.accept("./login-with-password.vue?vue&type=template&id=04c9de07&", function () {
      api.rerender('04c9de07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/login-with-password.vue"
export default component.exports